import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { AssembleiaItemOpcaoVoto } from "../model/AssembleiaItemOpcaoVoto";
import { AbOpcaoVoto } from "app/abstract/full-pages/assembleia/opcao-voto.abstract";

@Injectable({ providedIn: 'root' })
export class OpcaoVotoService extends AbOpcaoVoto {
    prefixo = 'opcao_votos/';

    constructor(httpClient: HttpClient) {
        super(httpClient);
    }

    public salvarAlterarDados(entity: AssembleiaItemOpcaoVoto) {
        return this.save(this.prefixo, entity);
    }

    public getAllOpcaoVoto() {
        return this.getAll(`${this.prefixo}all`);
    }
}
